import { PaginatedVacationBonusQueryVariables } from "@/graphql/__generated__/graphql";
import DateRangeFilter from "../../Shared/DateRangeFilter";
import { format } from "date-fns";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedVacationBonusQueryVariables) => void;
}

/**
 * VacationBonusDateRange component for filtering vacation bonus by date range
 * @param props Component properties
 * @returns JSX element
 */
function VacationBonusDateRange({ displayAmount, handleSubmitClick }: Props) {
  const vacationBonusDateConfig = {
    paginationStateKey: "paginatedVacationBonus" as keyof PaginationState,
    dateFieldName: "activeFrom",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      dateRange: { gte: Date | null; lte: Date | null },
      sort?: any
    ): PaginatedVacationBonusQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: (dateRange.gte === null && dateRange.lte === null) ? null : {
          gte: dateRange.gte ? format(dateRange.gte, "yyyy-MM-dd") + "T00:00:00+00:00" : null,
          lte: dateRange.lte ? format(dateRange.lte, "yyyy-MM-dd") + "T23:59:59+00:00" : null,
        },
        bonusRelative: filters.bonusRelative || null,
        bonusAbsolute: filters.bonusAbsolute || null,
        provinces: filters.provinces || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      bonusRelative: paginationState.filters?.bonusRelative,
      bonusAbsolute: paginationState.filters?.bonusAbsolute,
      provinces: paginationState.filters?.provinces,
    })
  };

  return (
    <DateRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={vacationBonusDateConfig}
    />
  );
}

export default VacationBonusDateRange;
